import {Version, VersionComponent, StringRepresentation} from '../types';

function toNumber(s: string): VersionComponent {
  return !Number.isNaN(parseInt(s, 10)) ? +s : -1;
}

export function parseVersion(version: StringRepresentation): Version {
  const [major, minor, patch] = (version || '').toString().split('.');

  return {
    major: toNumber(major),
    minor: toNumber(minor),
    patch: toNumber(patch),
  };
}
